import React, { useContext, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { displayContext } from '@/components/pages/assessments/context/display.context';

const QuestionString = ({ question, answer, setAnswer, setQuestionComplete, previewOnly = false }) => {
  const { css } = useContext(displayContext);
  const [value, setValue] = useState(answer || '');
  const required = !!question.required;

  useEffect(() => {
    if (!previewOnly) {
      setQuestionComplete(!required || (value !== null && value !== undefined && value !== ''));
      setAnswer(value);
    }
  }, [value, previewOnly]);

  return (
    <div className={`question-input question-string ${css('question-string')}`}>
      <Form.Group>
        <Form.Control
          onChange={(e) => {
            if (!previewOnly) {
              setValue(e.target.value);
            }
          }}
          value={value}
          type="text"
          placeholder={question.helper_text}
          disabled={previewOnly}
          readOnly={previewOnly}
        />
        <label>{question.helper_text}</label>
      </Form.Group>
    </div>
  );
};

export default QuestionString;
